function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { KEY_FILTER1, KEY_FILTER2 } from "../types/filter";
export var LIST_API_MAP = {
  default: '/flow/core/query/order/pending/list',
  已发起: '/flow/core/query/order/apply/list'
};

// 分类全部的时候Code值
export var CLASSIFY_CODE_ALL = 'all-0';
// “全部”的起始时间
export var ALL_START_TIME = '2000-01-01';
export var FILTER2_MAP = {
  全部: {
    text: '全部',
    queryKey: KEY_FILTER2,
    value: '0'
  },
  即将超时: {
    text: '即将超时',
    queryKey: KEY_FILTER2,
    value: '1'
  },
  已超时: {
    text: '已超时',
    queryKey: KEY_FILTER2,
    value: '2'
  }
};
var SUB_FILTER = [FILTER2_MAP.全部, FILTER2_MAP.即将超时, FILTER2_MAP.已超时];
export var FILTER_MAP = {
  待处理: {
    text: '待处理',
    subFilter: SUB_FILTER,
    value: '1',
    query: _defineProperty({}, KEY_FILTER1, '1')
  },
  已处理: {
    text: '已处理',
    subFilter: SUB_FILTER,
    value: '3',
    query: _defineProperty(_defineProperty({}, KEY_FILTER1, '3'), KEY_FILTER2, '0')
  },
  待阅读: {
    text: '待阅读',
    subFilter: SUB_FILTER,
    value: '2',
    query: _defineProperty({}, KEY_FILTER1, '2')
  }
  // 已发起: {
  //   text: '已发起',
  //   subFilter: SUB_FILTER,
  //   filterSchema: undefined, // 已发起不展示筛选按钮
  //   value: '4',
  //   query: {
  //     [KEY_FILTER1]: '4',
  //   },
  // },
};